import angular from 'angular'
import taxDiskCtrl from './list'
import listPage from './view/list.html'


function configRouter ($stateProvider) {
    $stateProvider.state(
        'system.basedata.taxDisk',
        {
            url: '/taxDisk',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'system.basedata.taxDisk.list',
            title: '金税盘管理',
        },
    )
    $stateProvider.state(
        'system.basedata.taxDisk.list',
        {
            url: '/list',
            template: listPage,
            controller: 'taxDiskCtrl',
        },
    )
}

export default angular
    .module('system.syssetting.taxDiskCtrl', [])
    .config(['$stateProvider', configRouter])
    .controller('taxDiskCtrl', taxDiskCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxDisk/index.js